import { hasArrayElements } from "@/apiUtils/commonUtils";
import { lensConfigurationSteps } from "@/apiUtils/constants";
import { endPageTransition, startPageTransition } from "@/apiUtils/pageLoadingUtils";
import InfoIcon from "@/assets/icons/info.svg?react";
import {
  ConfiguratorStepProps,
  LensCustomizationData,
  LensCustomizationOptions,
} from "@/common/lib/types";
import { cn } from "@/lib/tailwind";
import { getPreviousStep } from "@/utils/lensConfigurator";
import { useState } from "react";
import Navigation from "../../components/Navigation";
import { useConfiguratorContext } from "../../context/Provider";
import SummaryReview from "../../summaryReview/SummaryReview";
import LensCustomizeCard from "./LensCustomizeCard";
import LensInfoOverlay from "./LensInfoOverlay";
import ShodoIcon from "@/assets/icons/shodo.png";
import Image from "next/image";

interface ILensCustomizationStepProps extends ConfiguratorStepProps {
  stepOptions: LensCustomizationOptions;
}

const LensCustomize = ({
  locale,
  stepOptions,
  translations,
  currencyCode,
  handleStepData,
  handleJumpToStep,
}: ILensCustomizationStepProps) => {
  const [openLensInfoModal, setOpenLensInfoModal] = useState(false);
  // const [advancedMenu, setAdvancedMenu] = useState<boolean | undefined>(undefined);
  const { loading, updateSkippedSteps, skippedSteps, steps } = useConfiguratorContext();

  // const lang = getLangFromLocale(locale);
  const { data, lensInfo: lensInfoData } = stepOptions;
  const currentStep = lensConfigurationSteps.LENS_CUSTOMIZATION;

  // const handleToggleAdvancedMenu = (open: boolean) => {
  //   if (open) {
  //     updateSkippedSteps(
  //       skippedSteps.filter((step) => step !== lensConfigurationSteps.ADDITIONAL_OPTIONS),
  //     );
  //   } else {
  //     updateSkippedSteps([...skippedSteps, lensConfigurationSteps.ADDITIONAL_OPTIONS]);
  //   }
  //   setAdvancedMenu((prev) => !prev);
  // };

  const handleBack = async () => {
    if (!handleJumpToStep || typeof handleJumpToStep !== "function") return;
    startPageTransition(false);
    await handleJumpToStep(getPreviousStep(currentStep, steps, skippedSteps));
    endPageTransition();
  };

  const handleSelect = async (data: LensCustomizationData) => {
    if (data.custom) return;
    startPageTransition(false);
    await handleStepData(currentStep, data, 1);
    endPageTransition();
  };

  console.log("Lens Customize stepOptions", { stepOptions });

  return (
    <div>
      <section className="hidden w-full gap-4 lg:flex">
        <Navigation disabled={loading} className="px-4" onGoBack={handleBack}>
          {translations?.lensConfigurator?.lens_config_bundles_section_title?.toUpperCase()}
        </Navigation>
        {lensInfoData && (
          <button
            onClick={() => setOpenLensInfoModal(true)}
            className="-mt-[18px] flex items-center gap-1 text-[0.75rem]"
          >
            <span>{lensInfoData.badgeTitle}</span>
            <Image src={ShodoIcon} width={35} height={33} alt="shodo-icon"/>
            <InfoIcon className="h-4 w-4" />
          </button>
        )}
      </section>
      <section className="mb-2 flex items-center gap-4 lg:hidden px-4">
        <p>{translations?.lensConfigurator?.lens_config_bundles_section_title}</p>
        {lensInfoData && (
          <button
            onClick={() => setOpenLensInfoModal(true)}
            className="flex items-center gap-1 text-[0.75rem]"
          >
            <span className="mt-[3px]">{lensInfoData.badgeTitle}</span>
            <Image src={ShodoIcon} width={35} height={33} alt="shodo-icon" />
            <InfoIcon className="h-4 w-4" />
          </button>
        )}
      </section>

      <section className="px-4">
        <p className="mb-7 text-[0.75rem] ">
          <span className="mr-1 font-bold">
            {translations?.lensConfigurator?.lens_config_bundles_section_subtitle_bold_text}
          </span>
          <span>{translations?.lensConfigurator?.lens_config_bundles_section_subtitle}</span>
        </p>
      </section>

      {hasArrayElements(data) && (
        <div className="grid grid-flow-row items-start gap-3 px-4">
          {data.map((item, i) =>
            item.price === "0" ? (
              <></>
            ) : (
              <LensCustomizeCard
                key={i}
                item={item}
                locale={locale}
                translations={translations}
                currencyCode={currencyCode}
                onSelect={() => handleSelect(item)}
                className={cn(data.length < 3 ? "md:col-span-6 lg:col-span-6" : "")}
              />
            ),
          )}
        </div>
      )}
      <SummaryReview currencyCode={currencyCode} locale={locale} translations={translations} />
      <LensInfoOverlay
        lensInfo={lensInfoData}
        open={openLensInfoModal}
        onClose={() => setOpenLensInfoModal(false)}
      />
    </div>
  );
};

export default LensCustomize;
